import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_BASE } from "@/lib/api";
import { Loader2 } from "lucide-react";

/**
 * Catch-all redirect: /:slug → backend /api/r/:slug.
 * Uses full page load so the backend logs the click with referrer/UA.
 */
export default function SlugRedirect() {
  const { slug } = useParams();

  useEffect(() => {
    if (!slug) return;
    // Full-page redirect so backend logs click (with Referer + UA + IP)
    window.location.replace(`${API_BASE}/api/r/${slug}`);
  }, [slug]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      <div className="text-xs text-muted-foreground font-mono">Redirecting…</div>
    </div>
  );
}
